import React from 'react'
import {Redirect} from 'react-router-dom'

import querystring from 'querystring';
// REACT TOOLBOX COMP
import Button from "react-toolbox/lib/button/Button"
import Checkbox from 'react-toolbox/lib/checkbox/Checkbox'
import Input from "react-toolbox/lib/input/Input"
import '../../../assets/react-toolbox/theme.css';
import theme from '../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
// CUSTOM COMP
import {Logo} from '../../Map/Common/Logo'
import LogoSVG_Blue from '../../../images/Bettair_Logo_Blue.png'
import {EuropeanInfo} from './EuropeanInfo'
//IDM CSS
import './idm.css'
/*** REDUX  ****/
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
/*** REDUX ACTINS ***/
import * as UserActions from "../../../actions/user";

import {getUserToken} from '../../../requests/user'

class Index extends React.Component {
    constructor() {
        super();

        this.state = {
            email: "",
            password: "",
            remember: true,
            fireRedirect: false,
            warningPassword: false,
            warningEmail: false,
            warning: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    componentDidMount() {
        this.props.userActions.getUserInfo();
    }

    handleChange(name, value) {
        if (value === '' && name === 'email')
            this.setState({...this.state, [name]: value, warningEmail: true, warning: false});
        if (value === '' && name === 'password')
            this.setState({...this.state, [name]: value, warningPassword: true, warning: false});
        else
            this.setState({
                ...this.state,
                [name]: value,
                warningEmail: name === 'email' ? false : this.state.warningEmail,
                warning: false,
                warningPassword: name === 'password' ? false : this.state.warningPassword
            });
    };

    handleSubmit(e) {
        if (this.state.email === "")
            this.setState({...this.state, warningEmail: true, warning: false})
        else if (this.state.password === "")
            this.setState({...this.state, warningPassword: true, warning: false})
        else {

            getUserToken(querystring.stringify({
                grant_type: "password",
                username: this.state.email,
                password: this.state.password
            }), (response, err) => {
                if (!err) {
                    sessionStorage.setItem('x-auth-token', response.data.access_token);
                    sessionStorage.setItem('refresh_token', response.data.refresh_token);
                    if(this.state.remember)
                        localStorage.setItem('refresh_token', response.data.refresh_token);

                    this.props.userActions.getUserInfo();

                } else {
                    this.setState({...this.state,warning: true})

                }
            })
        }
    };

    handleKey(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleSubmit();
        }

    }

    render() {
        const search = this.props.location.search; // could be '?foo=bar'
        const params = new URLSearchParams(search);
        const h = params.get('h') ? params.get('h') : '/dashboard';

        return (
            <ThemeProvider theme={theme}>
                <div className="loginPage">
                    <div className="row loginContent">
                        <div className="col-xs-12  loginForm">
                            <form onKeyDown={this.handleKey.bind(this)}>
                                <Logo Logo={LogoSVG_Blue}/>
                                <br/>
                                <Input required type="text" label="Email" name="email"
                                       value={this.state.email}
                                       onChange={this.handleChange.bind(this, "email")}
                                />
                                {this.state.warningEmail &&
                                <h5 className={'warningMessage'}> Introduce a valid user name</h5>}

                                <Input required type="password" label="Password" name="password"
                                       value={this.state.password}
                                       onChange={this.handleChange.bind(this, "password")}/>

                                {this.state.warningPassword &&
                                <h5 className={'warningMessage'}> Introduce a password</h5>}
                                {this.state.warning &&
                                <h5 className={'warningMessage'}> Introduced user is not valid, please check user name
                                    or password</h5>}

                                <Checkbox checked={this.state.remember} label="Remember me"
                                          onChange={this.handleChange.bind(this, "remember")}/>
                                <Button label="SIGN IN" raised primary
                                        onClick={this.handleSubmit}
                                />
                            </form>
                            {this.props.logged && (
                                <Redirect to={h}/>
                            )}
                        </div>
                    </div>
                    <EuropeanInfo/>
                </div>
            </ThemeProvider>
        )
    }


}


const dashboardStateToProps = (state) => {
    return {
        logged: state.user.logged,
    }
};

const dashboardDispatchToProps = (dispatch) => {
    return {
        userActions: bindActionCreators(UserActions, dispatch),
    }
};


export default connect(dashboardStateToProps, dashboardDispatchToProps)(Index)



// WEBPACK FOOTER //
// ./src/components/Route/IdentityManager/index.js